const root = "/reports";

export type ReportsTab =
  | "unsigned-notes"
  | "signed-notes"
  | "patient-service-usage"
  | "staff-service-usage"
  | "patient-access"
  | "audit-logs"
  | "portal"
  | "recommendation-summary"
  | "audit-summary"
  | "virtual-scribe";

export const reportsRoutes = {
  root,
  tab: `${root}/:tab`,
} as const;
